import React from 'react';
import { SnippetVariable, generateFetchCode } from '../../../utils/schemaSnippets';
import { SyntaxHighlighter } from './SyntaxHighlighter';

export interface FetchSnippetProps {
  variables: SnippetVariable[];
  webhookUrl: string;
  ingestToken: string;
  className?: string;
}

export const FetchSnippet: React.FC<FetchSnippetProps> = ({
  variables,
  webhookUrl,
  ingestToken,
  className = '',
}) => {
  const code = generateFetchCode(webhookUrl, ingestToken, variables);
  return <SyntaxHighlighter code={code} language="javascript" className={className} />;
};
